import React from 'react';

import Backdrop from '@material-ui/core/Backdrop';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';

const StyledLoading = withStyles({
  root: {
    color: 'var(--white)'
  }
})(CircularProgress);

const SubmitOverlay = ({ isSubmitting, message = 'Uploading...' }) => {
  if (!isSubmitting) return null;

  return (
    <Backdrop open style={{ zIndex: 1 }}>
      <Box textAlign="center">
        <StyledLoading size={52} />
        <Box color="white" fontSize="1.4rem" marginTop={2}>
          {message}
        </Box>
      </Box>
    </Backdrop>
  );
};

export default SubmitOverlay;
